export default __webpack_public_path__ + "static/media/img-0817-czech-republic-premium-face.209f1214.png";